module.exports = ($scope, $stateParams, settings, actionLog, subject, User) ->
  $scope.user = User
  $scope.getCurrentPage = (offset, limit) ->
    if offset and limit
      offset / limit + 1
    else
      1

  $scope.flattenDiff = (diff) ->
    flat = {}
    if not diff[0] or diff[0].length == 0
      return {}

    for action in diff
      if action[0].length is 0 and Object.keys(action[1]).length > 0
        flat = action[1]
      else
        flat[action[0][0]] = action[1]
    flat

  $scope.loadData = (params) ->
    $scope.loading = true
    actionLog(params).then (actionLog) ->
      $scope.log = actionLog.results
      $scope.totalLogs = actionLog.count
      $scope.subject = subject
      $scope.loading = false

  $scope.loadPage = (page) ->
    $scope.page = page or $scope.page
    limit = settings.LOG_ENTRIES_PER_PAGE
    offset = ($scope.page - 1) * limit
    $scope.loadData
      offset: offset
      limit: limit

  $scope.loadData($stateParams)
  $scope.currentPage = $scope.getCurrentPage($stateParams.offset, $stateParams.limit)
